import { createAction } from 'typesafe-actions';

const IMPORT_ENTITIES = "@iiif/IMPORT_ENTITIES";
const MODIFY_ENTITY_FIELD = "@iiif/MODIFY_ENTITY_FIELD";
const REORDER_ENTITY_FIELD = "@iiif/REORDER_ENTITY_FIELD";
const ADD_REFERENCE = "@iiif/ADD_REFERENCE";
const REMOVE_REFERENCE = "@iiif/REMOVE_REFERENCE";
const importEntities = createAction(IMPORT_ENTITIES)();
const modifyEntityField = createAction(MODIFY_ENTITY_FIELD)();
const reorderEntityField = createAction(REORDER_ENTITY_FIELD)();
const addReference = createAction(ADD_REFERENCE)();
const removeReference = createAction(REMOVE_REFERENCE)();
const entityActions = { importEntities, modifyEntityField, reorderEntityField, addReference, removeReference };

const ADD_MAPPING = "@iiif/ADD_MAPPING";
const ADD_MAPPINGS = "@iiif/ADD_MAPPINGS";
const addMapping = createAction(ADD_MAPPING)();
const addMappings = createAction(ADD_MAPPINGS)();
const mappingActions = { addMapping, addMappings };

const SET_META_VALUE = "@iiif/SET_META_VALUE";
const SET_META_VALUE_DYNAMIC = "@iiif/SET_META_VALUE_DYNAMIC";
const UNSET_META_VALUE = "@iiif/UNSET_META_VALUE";
const setMetaValue = createAction(SET_META_VALUE)();
const setMetaValueDynamic = createAction(SET_META_VALUE_DYNAMIC)();
const unsetMetaValue = createAction(UNSET_META_VALUE)();
const metaActions = {
  setMetaValue,
  setMetaValueDynamic,
  unsetMetaValue
};

const RESOURCE_ERROR = "RESOURCE_ERROR";
const RESOURCE_LOADING = "RESOURCE_LOADING";
const RESOURCE_READY = "RESOURCE_READY";
const REQUEST_RESOURCE = "@iiif/REQUEST_RESOURCE";
const REQUEST_ERROR = "@iiif/REQUEST_ERROR";
const REQUEST_MISMATCH = "@iiif/REQUEST_MISMATCH";
const REQUEST_COMPLETE = "@iiif/REQUEST_COMPLETE";
const REQUEST_OFFLINE_RESOURCE = "@iiif/REQUEST_OFFLINE_RESOURCE";
const requestResource = createAction(REQUEST_RESOURCE)();
const requestError = createAction(REQUEST_ERROR)();
const requestMismatch = createAction(REQUEST_MISMATCH)();
const requestComplete = createAction(REQUEST_COMPLETE)();
const requestOfflineResource = createAction(REQUEST_OFFLINE_RESOURCE)();
const requestActions = {
  requestResource,
  requestError,
  requestMismatch,
  requestComplete,
  requestOfflineResource
};

const BATCH_ACTIONS = "@iiif/BATCH";
const BATCH_IMPORT = "@iiif/BATCH_IMPORT";
const batchActions = createAction(BATCH_ACTIONS)();
const batchImport = createAction(BATCH_IMPORT)();

export { ADD_MAPPING, ADD_MAPPINGS, ADD_REFERENCE, BATCH_ACTIONS, BATCH_IMPORT, IMPORT_ENTITIES, MODIFY_ENTITY_FIELD, REMOVE_REFERENCE, REORDER_ENTITY_FIELD, REQUEST_COMPLETE, REQUEST_ERROR, REQUEST_MISMATCH, REQUEST_OFFLINE_RESOURCE, REQUEST_RESOURCE, RESOURCE_ERROR, RESOURCE_LOADING, RESOURCE_READY, SET_META_VALUE, SET_META_VALUE_DYNAMIC, UNSET_META_VALUE, addMapping, addMappings, addReference, batchActions, batchImport, entityActions, importEntities, mappingActions, metaActions, modifyEntityField, removeReference, reorderEntityField, requestActions, requestComplete, requestError, requestMismatch, requestOfflineResource, requestResource };
